'use client';

import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { ReactNode, Ref, startTransition, useEffect, useState } from 'react';

import { useMediaQuery } from '@/ui-tool/media-query';

import { styles } from './UiKitTooltip.styles';

export interface UiKitTooltipProps {
  children: ReactNode;
  content?: ReactNode;
  className?: string;
  customTooltip?: ReactNode;
  delay?: number;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  ref?: Ref<HTMLDivElement>;
  withArrow?: boolean;
}
export function UiKitTooltip({
  children,
  content,
  customTooltip,
  delay = 200,
  side = 'top',
  align = 'center',
  ref,
  withArrow,
  className,
  ...props
}: UiKitTooltipProps) {
  const slots = styles();
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  const isDesktop = useMediaQuery('md');

  useEffect(() => {
    startTransition(() => {
      setMounted(true);
    });
  }, []);

  if ((!content && !customTooltip) || !mounted) {
    return <>{children}</>;
  }

  return (
    <TooltipPrimitive.Provider>
      <TooltipPrimitive.Root
        delayDuration={isDesktop ? delay : 0}
        open={open}
        onOpenChange={(e) => {
          setOpen(e);
        }}
      >
        <TooltipPrimitive.Trigger
          onClick={() => setOpen(true)}
          asChild
        >
          {children}
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          {customTooltip ? (
            customTooltip
          ) : (
            <TooltipPrimitive.Content
              ref={ref}
              side={side}
              align={align}
              className={slots.content({ className })}
              sideOffset={8}
              {...props}
            >
              {content}
              {withArrow && <TooltipPrimitive.Arrow className={slots.arrow()} />}
            </TooltipPrimitive.Content>
          )}
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}
